import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import { HomePage } from "./pages/HomePage";
import { Dashboard } from "./pages/Dashboard";
import { WorkspacePage } from "./pages/WorkspacePage";
import { AgentRedirect } from "./components/AgentRedirect";
import {loadConfig} from "./config"
import { SignedWalletProvider } from "./components/SignedWalletProvider";
import { ProtectedRoute } from './components/ProtectedRoute';
import { PageLayout } from './components/PageElements';
import { Licensing } from './pages/Licensing';
import { ModalAlertProvider } from './components/ModalAlert';

function PortfolioRedirect() {
  const { portfolioId } = useParams();
  return <Navigate to={`/workspace/${portfolioId}`} replace />;
}

function AnalyticsTracker() {
  useGoogleAnalytics();
  return null;
}

export default function App() {

  const [config, setConfig] = useState(null);

  useEffect(() => {
    loadConfig().then((configFetched) => {
      setConfig(configFetched);
      console.log(`App config: ${JSON.stringify(configFetched)}`);
      // Signal prerenderer that the app is ready to snapshot
      document.dispatchEvent(new Event('app-ready'));
    });
  }
  , []);

  return (
    <>{config && // App.jsx
<ModalAlertProvider>
<SignedWalletProvider config={config}>
  <BrowserRouter>
    <AnalyticsTracker />
    <Routes>
      {/* All routes inside this Layout will share the HeaderBar */}
      <Route element={<PageLayout config={config} />}>
        <Route path="/" element={<HomePage config={config} />} />
        <Route path="/licensing" element={<Licensing />} />
        {/* /plans is retired; SubscriptionPlans stays on disk but is unrouted.
            These are client-side fallbacks only — /plans still needs a real 301
            to /licensing at the edge (CloudFront) for search engines. */}
        <Route path="/plans" element={<Navigate to="/licensing" replace />} />
        <Route path="/licencing" element={<Navigate to="/licensing" replace />} />
        <Route path="/enterprise" element={<Navigate to="/licensing" replace />} />
        <Route path="/license" element={<Navigate to="/licensing" replace />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard config={config} />
            </ProtectedRoute>}
        />
        <Route
          path="/workspace/:portfolioId"
          element={
            <ProtectedRoute>
              <WorkspacePage config={config} />
            </ProtectedRoute>}
        />
        {/* Legacy redirects */}
        <Route
          path="/portfolio/:portfolioId"
          element={
            <ProtectedRoute>
              <PortfolioRedirect />
            </ProtectedRoute>}
        />
        <Route
          path="/agent/:agentId"
          element={
            <ProtectedRoute>
              <AgentRedirect config={config} />
            </ProtectedRoute>}
        />
      </Route>
    </Routes>
  </BrowserRouter>
</SignedWalletProvider>
</ModalAlertProvider>}</>
  );
}

